import React, { ReactElement, useEffect } from "react";
import Loader from "@screencloud/screencloud-ui-components/.dist/components/loader";

import "./AuthCallback.scss";

const AuthCallback = (): ReactElement<{}> => {
  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get("code");
    const state = JSON.parse(
      new URLSearchParams(window.location.search).get("state") || "{}"
    );
    const { provider } = state;
    if (code) {
      const parent = window.opener;
      parent && parent.postMessage({ code, provider }, window.location.origin);
      window.close();
    } else {
      window.close();
    }
  }, []);
  return (
    <div className="authCallbackContainer">
      <Loader active size="massive" inline="centered" />
    </div>
  );
};

export default AuthCallback;
